import { getCanvasState } from '@components/ArtBoard/Canvas/helpers/canvas'
import { ELEMENT_GESTURE_MOVABLE_CONTAINER } from '@components/ArtBoard/Canvas/hooks/events/useDragEvents'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { GlobalActions } from '@/store'

const useDragToEdge = (isDragging: boolean) => {
  const [isStaysOnEdge, setIsStaysOnEdge] = useState({
    left: false,
    right: false,
    top: false,
    bottom: false,
  })

  const dispatch = useDispatch()

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null

    if (
      isStaysOnEdge.left ||
      isStaysOnEdge.right ||
      isStaysOnEdge.top ||
      isStaysOnEdge.bottom
    ) {
      intervalId = setInterval(() => {
        const ref = document.getElementById(ELEMENT_GESTURE_MOVABLE_CONTAINER)
        const canvas = getCanvasState(ref)

        const { scale } = canvas
        let tx = canvas.translate[0]
        let ty = canvas.translate[1]

        if (isStaysOnEdge.left) {
          tx += 10
        }

        if (isStaysOnEdge.right) {
          tx -= 10
        }

        if (isStaysOnEdge.top) {
          ty += 10
        }

        if (isStaysOnEdge.bottom) {
          ty -= 10
        }

        dispatch(
          GlobalActions.updateCanvas({
            scale,
            translate: [tx, ty],
          })
        )
      }, 10)
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [isStaysOnEdge])

  useEffect(() => {
    if (!isDragging) {
      setIsStaysOnEdge({
        left: false,
        right: false,
        top: false,
        bottom: false,
      })
    }
  }, [isDragging])

  return (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (event.clientX < 5) {
      if (!isStaysOnEdge.left) {
        setIsStaysOnEdge({ ...isStaysOnEdge, left: true })
      }
    }

    if (event.clientY < 5) {
      if (!isStaysOnEdge.top) {
        setIsStaysOnEdge({ ...isStaysOnEdge, top: true })
      }
    }

    if (event.clientX > window.innerWidth - 5) {
      if (!isStaysOnEdge.right) {
        setIsStaysOnEdge({ ...isStaysOnEdge, right: true })
      }
    }

    if (event.clientY > window.innerHeight - 5) {
      if (!isStaysOnEdge.bottom) {
        setIsStaysOnEdge({ ...isStaysOnEdge, bottom: true })
      }
    }

    if (
      event.clientX > 5 &&
      event.clientY > 5 &&
      event.clientX < window.innerWidth - 5 &&
      event.clientY < window.innerHeight - 5
    ) {
      setIsStaysOnEdge({
        left: false,
        right: false,
        top: false,
        bottom: false,
      })
    }
  }
}

export default useDragToEdge
